var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-modal',{attrs:{"title":"Produkt hinzufügen","action":"create","on-submit":_vm.submit,"on-close":() => _vm.$emit('close')}},[_c('CreateForm',{attrs:{"product":_vm.product,"product-templates":_vm.productTemplates,"product-readable-ids":_vm.productReadableIds}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }